<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Cajas activas</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in cajas"
                v-bind:key="item.CashierLoginID"
                :value="item.CashierLoginID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-12" style="">
                  <span
                    style="margin-left: 10px;margin-top: 35px; font-size:42px; float:left"
                    class="fa fa-fw fa-cash-register"
                  />
                  <div style="margin-left: 10px;margin-top: 22px; margin-bottom:22px; float:left">
                    <div>
                      {{item.BranchOfficeName}}
                      <br />
                      {{item.CashBoxName}}
                      <br />
                      {{item.UserName}}
                    </div>
                  </div>
                  <button
                    type="button"
                    @click="itemClicked(item)"
                    class="btn btn-primary"
                    style="border-bottom:10px; float:right; margin-top: 35px"
                  >
                    Desloguear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

export default {
  components: { KitsCombo, KitsBusquedaSimple },
  data() {
    return {
      model: {},
      cajas: []
    };
  },
  methods: {
    itemClicked(item) {
      let context = this;
      axiosHelpers.axiosPost(
        "Commerce/LogoutCashBox",
        { CashierLoginID: item.CashierLoginID },
        this,
        function(data) {
          if (data.ResponseVM.Result) {
            notificationHelpers.showSuccess('Éxito', 'Se deslogueo la caja correctamente', context);
            context.cargarCajas();
          }
        }
      );
    },
    cargarCajas() {
      let context = this;

      axiosHelpers.axiosPost("Commerce/GetLoggedCashBoxes", {}, this, function(
        data
      ) {
        context.cajas = data.ResponseVM.Items;
      });
    }
  },
  beforeMount: function() {
    this.cargarCajas();
  }
};
</script>